'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lightBaseTheme = require('../baseThemes/lightBaseTheme');

var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _lightBaseTheme2.default;

// import deprecatedExport from '../../utils/deprecatedExport';

// export default deprecatedExport(
//   lightBaseTheme,
//   'material-ui/lib/styles/raw-themes/light-raw-theme',
//   'material-ui/lib/styles/baseThemes/lightBaseTheme'
// );

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/lib/styles/raw-themes/light-raw-theme.js
 ** module id = 303
 ** module chunks = 0
 **/